import React, { Component,useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Header from '../common/layout/header';
import Footer from '../common/layout/footer'; 
import { BaseUrl } from '../common/config';
import Sidebar from '../common/sidebar'; 
import moment from 'moment';
import CommonAlert from '../common/Commonalert';
import { http } from '../helper';
import ShowAlert from '../common/Showalert';
const Freecodeadd =()=>
{

  const [Freecode,setFreeCode] = useState([]);
  const [Freecodelist,setFreeCodeList] = useState([]);
  const [errmessage, setErrMessage] = useState({});
  const [Freecodestatus,setFreeCodeStatus] = useState('A');
  const [alertPopup,setAlertPopup] = useState(false);
  const [alertMessage,setAlertMessage] = useState([]);
  const [alerterrorPopup,setAlertErrorPopup] = useState(false);
  const [alerterrMessage,setAlerterrMessage] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [enableAddToCart, setEnableAddToCart] = useState([]);
  const [maxProductsAllowed, setMaxProductsAllowed] = useState(0);
  const [allProducts, setAllProducts]= useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [groupedProducts, setGroupedProducts] = useState({
    pizza: [],
    pasta: [],
    burrito: [],
    desserts: []
});
  if(!sessionStorage.getItem("isLoggedIn")){
    window.location.href = '/';
}
if(JSON.parse(sessionStorage.getItem('authData')) != '' && !JSON.parse(sessionStorage.getItem('authData')).adminRole.permissions.includes('manage_foodsolutions'))
    {
      window.location.href = '/unauthorized';
    }
const routeChange = (e) =>{ 
    e.preventDefault();
    window.location.href='/freesample/freecode';
}

useEffect(()=>
{
    getFreecodelist();
    getAllProducts();
},[])

 // Fetch all products and categorize them
 const getAllProducts = () => {
    const priceCode = "PL1";
    let URL = `${BaseUrl}admin/productprice/${priceCode}`;
    
    http.get(URL).then((response) => {
      const products = response.data.data;
      setAllProducts(products); // Store fetched products
      const grouped = groupProductsByCategory(products); // Group products by category
      setGroupedProducts(grouped); // Update the state with grouped products
    }).catch((err) => {
      console.log(err);
    });
  };
   // Function to group products by category
   const groupProductsByCategory = (products) => {
    const categoryMap = {
      pizza: ["1"],
      pasta: ["10", "13"],
      burrito: ["11", "12"],
      desserts: ["14"]
    };
    const groupedProducts = {
        pizza: [],
        pasta: [],
        burrito: [],
        desserts: []
      };

    // Group products based on their category ID
    products.forEach((product) => {
        Object.keys(categoryMap).forEach((category) => {
          if (categoryMap[category].includes(product.categoryId)) {
            groupedProducts[category].push(product);
          }
        });
      });
  
      return groupedProducts;
    };

const getFreecodelist=()=> {

    let URL = BaseUrl + "admin/freecodelist";
        http.get(URL).then((response) => {
            setFreeCodeList(response.data.data);
           
        }).catch((err) => {
            console.log(err);
        })
    }

  const submitButton = (e) => {

    e.preventDefault();
    const isValid = formvalidation();

    if(isValid){
        let URL = BaseUrl +"admin/addfreecode";
        const payload = {
            Code: Freecode.trim(),
            //Freecodestatus : Freecodestatus,
            selectedCategories:selectedCategories,
            selectedProducts: selectedProducts, 
            enableAddToCart:enableAddToCart,
            NumberofProductsallowed: parseInt(maxProductsAllowed)
            };

            const isFound = Freecodelist.some(element => {
                if (element.Code === Freecode.trim()) {
                  return true;
                }
            
                return false;
              });
            if(isFound)
            {
                setAlertErrorPopup(true);
                setAlerterrMessage('This Code has already been added'); 
    
            }
            else
            {
 
                    var loginDetails = {};
                    if (sessionStorage.getItem('authData')) {
                        loginDetails = JSON.parse(sessionStorage.getItem('authData'));
                    }
                
                    http.post(URL,payload).then((response)=>{
            
                        let responseData = response.data.data;
                        if (response.data.success === true) {
                            
                            setAlertPopup(true);
                            setAlertMessage('Free Code has been added successfully'); 
                        }
            
                    }).catch((error)=>{
                        console.log(error)
                
                    });
            }

    }
     
}

const accObjectiveoptions = Array.from({ length: 100 }, (_, i) => i)

const formvalidation = () =>
{
    
    const errmessage = {};
    let isValid = true;
    
    if(Freecode == '' )
    {
        errmessage.freecodeerr = "Code is Required";
        isValid = false;
    }
    else if(Freecode.length < 5 )
    {
        errmessage.freecodeerr = "Incorrect Account Code. Please try again.";
        isValid = false; 
    }
    
   
    if (selectedCategories.length === 0) {
        errmessage.categoryErr = "At least one category must be selected.";
        isValid = false;
    }
    setErrMessage(errmessage);
    return isValid;
}

   const handleChange = (e) => {

       
        var re = /^\S/;
        if(e.target.name == 'Freecode')
        {
            if (e.target.value === '' || re.test(e.target.value))
            setFreeCode(e.target.value);
            setErrMessage('');
        }
        if(e.target.name == 'Freecodestatus')
        {
            setFreeCodeStatus(e.target.value);
        }
};
// When a product is checked/unchecked
const handleProductToggle = (productNumber) => {
    setSelectedProducts(prevSelected => {
        if (prevSelected.includes(productNumber)) {
            // If product is already selected, remove it
            return prevSelected.filter(num => num !== productNumber);
        } else {
            // If product is not selected, add it
            return [...prevSelected, productNumber];
        }
    });
};

const handleCategoryChange = (category) => {
  setSelectedCategories((prev) => {
      const newCategories = prev.includes(category)
          ? prev.filter((item) => item !== category)
          : [...prev, category];
      if (!newCategories.includes(category)) {
          // If unchecked, remove the products
          setSelectedProducts((prevSelected) => {
              const productsToRemove = groupedProducts[category]
                  ?.filter((product) => product.PDP_Status === "activate")
                  .map((product) => product.productNumber);
              return prevSelected.filter((productNumber) => !productsToRemove.includes(productNumber));
          });
      } else {
          // If checked, add the products
          setSelectedProducts((prevSelected) => {
              const activeProducts = groupedProducts[category]
                  ?.filter((product) => product.PDP_Status === "activate")
                  .map((product) => product.productNumber);

              const updatedSelection = [...prevSelected, ...activeProducts];
              return [...new Set(updatedSelection)];
          });
      }
      return newCategories;
  });
};

  const handleEnableAddToCart = (category) => {
    setEnableAddToCart((prev) =>
        prev.includes(category) ? prev.filter((c) => c !== category) : [...prev, category]
    );
};

  return (
    <>
    { alerterrorPopup &&  ( <ShowAlert title='Alert' message={alerterrMessage}/> )}
    {alertPopup && ( <CommonAlert title='Alert' message={alertMessage}/> )}
        <div className="dashboard-block">
            
                <Sidebar />
           
            <div className="dash-left">
                <Header />
                <section className="cart-block">
                <div className="container">
                    <h1 className="checkout-title vi">Add Free Code</h1> 

                    <div className="right-table-outer-wrap"> 
                     <div className='myact-wrap'>
                        <div className='client-details'>
                            <div className='form-field holiday-add-fieldset'>
                                <form className='form-field freecode-fieldset holiday-add-fieldset' method='post' onSubmit={submitButton}>
                                    <div className='input-field col-1'>
                                        <label htmlFor='name'>Code</label>
                                        <input type="text" onChange={handleChange} value={Freecode} name='Freecode' placeholder='Enter Code' />
                                        {errmessage.freecodeerr && (<div className="error-msg">{errmessage.freecodeerr}</div>)} 
                                    </div>

                                    <div className="add-free-samp-disp">
                                    
                                        <h4>Category</h4>
                                        <div className="add-free-samp-chks">
                                        {["pizza", "pasta", "burrito", "desserts"].map((category, index) => {
                                            let displayCategory = category === "pasta" ? "Pasta, Rice & Noodle Sauces" : category.charAt(0).toUpperCase() + category.slice(1);
                                           return (
                                    <div className="add-check-box-wrap" key={index}>
                                        <div className="check-box">
                                            <input
                                                type="checkbox"
                                                id={`freeCat${index}`}
                                                name={category}
                                                checked={selectedCategories.includes(category)}
                                                onChange={() => handleCategoryChange(category)}
                                            />
                                            <label htmlFor={`freeCat${index}`}>{displayCategory}</label>
                                        </div>
                                    
                                        {selectedCategories.includes(category) && (
                                  <>
                                    {/* Enable Add to Cart Switch */}
                                    <div className='switch-button-holder'>
                                      <label>Enable Add to Cart</label>
                                      <div className="switch-button">
                                        <input
                                          type="checkbox"
                                          className="checkbox"
                                          checked={enableAddToCart.includes(category)}
                                          onChange={() => handleEnableAddToCart(category)}
                                        />
                                        <div className="knobs"><span></span></div>
                                        <div className="layer"></div>
                                      </div>
                                    </div>

                                    {/* Product List */}
                                    <div className="product-list">
                                      {groupedProducts[category]?.map((product,index) => {
                                        const isInactive = product.PDP_Status !== "activate";
                                        return (
                                          <div key={product.productNumber} className="check-box">
                                             <input
                                                type="checkbox" id={`chkbox${category}${index}`}
                                                name='prd_chkbox' 
                                                checked={selectedProducts.includes(product.productNumber)}
                                                onChange={() => handleProductToggle(product.productNumber)}
                                                disabled={isInactive}
                                              />
                                             <label htmlFor={`chkbox${category}${index}`}>{product.productDescription} ({product.productNumber})</label>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </>
                                )}
                              </div>
                            );
                          })}
                        </div>
                        {errmessage.categoryErr && <div className="error-msg">{errmessage.categoryErr}</div>}
                      </div>
                                    <div className='input-field col-1'>
                                        <label htmlFor='name'>Maximum number of products allowed in the cart</label>
                                        <select className='cartVal' value={maxProductsAllowed} 
                                            onChange={(e) => setMaxProductsAllowed(e.target.value || "0")}>
                                            <option value="">Select value</option>
                                            {accObjectiveoptions.map((number) => (
                                            <option key={number} value={number}>
                                                {number}
                                            </option>
                                            ))}
                                        </select>
                                    </div>

                                 <div className='btnfield'>
                                 <button type='submit' className="submitbtn" >Submit</button>
                                  &nbsp;&nbsp;
                                  <button className="submitbtn" onClick={routeChange}>Cancel</button>
                                 </div>

            

                           </form>
                            </div>
                        </div>
                      </div>

                     </div>
                     </div>
                </section>
                <Footer />
               
            </div>
        </div>
		
    </>
);


}
export default Freecodeadd;

  

   